import { t } from '@sportninja/common/i18n'

/**
 * `t` is loosely typed in `common/i18n`, and every call site in this feature
 * needs a string back. One cast here beats one per render.
 */
const translate = t as (
  key: string,
  options?: Record<string, unknown>
) => string

export const gameViewsLabel = (
  key: string,
  params?: Record<string, unknown>
): string => translate(`common:${key}`, params)
